<template>
  <div v-if="rows">
    <DataTable :value="rows" tableStyle="width: 90rem">
        <Column v-for="col of headers" :key="col" :field="col" :header="col"></Column>
    </DataTable>
  </div>
  <div v-else>
    <Message severity="error">Errore</Message>
  </div>
</template>

<script>
  import { ref, onMounted } from "vue";

  export default {
    props: {
      data: {
        type: Object
      }
    },

    setup(props){
      const rows = ref()
      const headers = ref()

      onMounted(()=>{
        rows.value = props.data.data.length ? props.data.data : null
        headers.value = props.data.headings
      })

      return {
        rows,
        headers,
      }
    }
  }
</script>

<style scoped>
  
</style>
